import './recommendations-item.scss';
